import { useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useSnackbar } from 'notistack';
import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, Grid, TextField } from '@mui/material';

import { District } from '@/types';
import { useCreateDistrictMutation } from '@/services';
import { messages } from '@/utils/helpers';

export interface CreateDistrictProps extends DialogProps {
  onClose(): void;
}

const CreateDistrict: React.FC<CreateDistrictProps> = ({ onClose, ...props }) => {
  const { areaId } = useParams<{ areaId: string }>();
  const { enqueueSnackbar } = useSnackbar();

  const [createDistrict, createDistrictResponse] = useCreateDistrictMutation();

  const { values, errors, touched, handleSubmit, handleChange } = useFormik<District>({
    initialValues: {
      name: '',
    },
    validationSchema: yup.object().shape({
      name: yup.string().required(messages.form.REQUIRED),
    }),
    async onSubmit(district, { resetForm }) {
      try {
        await createDistrict({ ...district, parent_id: Number(areaId) }).unwrap();

        onClose();
        resetForm();
      } catch (error) {
        enqueueSnackbar(error.data, { variant: 'error' });
      }
    },
  });

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">Добавить округ</DialogTitle>

      <form onSubmit={handleSubmit}>
        <DialogContent dividers>
          <Grid container spacing={3}>
            <Grid item lg={6} md={6} xs={12}>
              <TextField
                name="name"
                label="Наименование"
                placeholder="Введите значение"
                value={values.name}
                onChange={handleChange}
                disabled={createDistrictResponse.isLoading}
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name ? errors.name : ''}
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            type="button"
            color="secondary"
            variant="outlined"
            disabled={createDistrictResponse.isLoading}
            onClick={onClose}
          >
            Закрыть
          </Button>

          <Button type="submit" variant="contained" disabled={createDistrictResponse.isLoading}>
            Добавить
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CreateDistrict;
